import { MILLISECONDS_PER_DAY } from '../constants';

export const getRateLockPeriod = plannedClosingDate => {
  const today = new Date();
  const closingDate = new Date(plannedClosingDate);
  const milliSecondsDiff = closingDate.getTime() - today.getTime();
  
  const nearestWholeNumberDaysUntilClose = Math.round(milliSecondsDiff / MILLISECONDS_PER_DAY);
  const numberOfFifteenDaysUntilClose = Math.ceil(nearestWholeNumberDaysUntilClose / 15);
  if(numberOfFifteenDaysUntilClose < 1) {
    return 15;
  } else if (numberOfFifteenDaysUntilClose > 5) {
    return 90;
  }
  return numberOfFifteenDaysUntilClose * 15;
}
